import React from 'react';
import { IconProps } from '../types';
const MinecraftMangroveSign: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="2" y="2" width="1" height="1" fill="rgba(139, 77, 58, 255)" />
<rect x="3" y="2" width="1" height="1" fill="rgba(139, 77, 58, 255)" />
<rect x="4" y="2" width="1" height="1" fill="rgba(127, 66, 52, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(127, 66, 52, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(127, 66, 52, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(127, 66, 52, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(139, 77, 58, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(127, 66, 52, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="14" y="2" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="2" y="3" width="1" height="1" fill="rgba(127, 66, 52, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(83, 30, 28, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(33, 25, 11, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(83, 30, 28, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(83, 30, 28, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(33, 25, 11, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(33, 25, 11, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(33, 25, 11, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(83, 30, 28, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(33, 25, 11, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(33, 25, 11, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(83, 30, 28, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(33, 25, 11, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(100, 36, 35, 255)" />
<rect x="2" y="5" width="1" height="1" fill="rgba(139, 77, 58, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(117, 49, 54, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(127, 66, 52, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(83, 30, 28, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(83, 30, 28, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(83, 30, 28, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(83, 30, 28, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(83, 30, 28, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="14" y="6" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(33, 25, 11, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(33, 25, 11, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(33, 25, 11, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(33, 25, 11, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(83, 30, 28, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(33, 25, 11, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(33, 25, 11, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(33, 25, 11, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="14" y="7" width="1" height="1" fill="rgba(100, 36, 35, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(139, 77, 58, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(119, 57, 52, 255)" />
<rect x="14" y="8" width="1" height="1" fill="rgba(117, 49, 54, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="14" y="9" width="1" height="1" fill="rgba(111, 42, 45, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(93, 28, 30, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(93, 28, 30, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(93, 28, 30, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(93, 28, 30, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(93, 28, 30, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(93, 28, 30, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(93, 28, 30, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(93, 28, 30, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(93, 28, 30, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(93, 28, 30, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(93, 28, 30, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(93, 28, 30, 255)" />
<rect x="14" y="10" width="1" height="1" fill="rgba(93, 28, 30, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(68, 53, 34, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(78, 63, 39, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(60, 47, 35, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(78, 63, 39, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(90, 72, 44, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(68, 53, 34, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(68, 53, 34, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(78, 63, 39, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(60, 47, 35, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(103, 82, 48, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(90, 72, 44, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(68, 53, 34, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(78, 63, 39, 255)" />
<rect x="8" y="15" width="1" height="1" fill="rgba(68, 53, 34, 255)" />
<rect x="9" y="15" width="1" height="1" fill="rgba(60, 47, 35, 255)" />
</svg>);
export default MinecraftMangroveSign;